import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { QuickQuestionOption } from '@gelato-api-ui/core/quick-questions/constants/quck-question-option';
import { WINDOW } from '@gelato-api-ui/core/window/window';

@Component({
  selector: 'gd-quick-question-answer-selection-control',
  templateUrl: './quick-question-answer-selection-control.component.html',
  styleUrls: ['./quick-question-answer-selection-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuickQuestionAnswerSelectionControlComponent implements AfterViewInit {
  @Input() options: QuickQuestionOption[];
  @Input() multiple = false;
  @Input() columnsCount = 'two';
  @Input() value: string | string[];
  @Input() collapse: number;
  @Output() valueChange = new EventEmitter<string | string[]>();

  @ViewChild('column', { read: ElementRef }) public column: ElementRef<HTMLElement>;
  @ViewChild('columns', { read: ElementRef }) public columns: ElementRef<HTMLElement>;

  public isViewMoreOpen = false;
  private columnsOriginalHeight: number;

  constructor(private readonly renderer: Renderer2, @Inject(WINDOW) private readonly window: Window) {}

  get collapseBtnTranslationKey(): string {
    return this.isViewMoreOpen ? 'txt_view_less_options' : 'txt_view_more_options';
  }

  ngAfterViewInit(): void {
    this.columnsOriginalHeight = this.columns.nativeElement.offsetHeight;
    this.collapseToggle();
  }

  collapseToggle(): void {
    if (this.columns) {
      const { nativeElement: container } = this.columns;
      const { nativeElement: columnElement } = this.column;

      this.renderer.addClass(container, 'collapse');

      const marginHeight = parseInt(this.window.getComputedStyle(columnElement).getPropertyValue('margin-bottom'));
      const columnHeight = (marginHeight + columnElement.offsetHeight) * this.collapse;
      const columnsHeight = this.isViewMoreOpen ? this.columnsOriginalHeight : columnHeight;

      if (this.isViewMoreOpen) {
        this.renderer.addClass(container, 'open');
      } else {
        this.renderer.removeClass(container, 'open');
      }

      this.renderer.setStyle(container, 'max-height', `${columnsHeight}px`);
    }
  }

  viewToggle(): void {
    this.isViewMoreOpen = !this.isViewMoreOpen;
    this.collapseToggle();
  }

  onOptionValueSelect(optionValue: string) {
    let newValue: string | string[] = optionValue;

    if (this.multiple) {
      newValue = this.value?.includes(optionValue)
        ? ((this.value as string[]) || []).filter((loopValueItem: string) => loopValueItem !== optionValue)
        : [...(this.value || ([] as string[])), optionValue];
    }

    this.valueChange.emit(newValue);
  }

  isActiveOptionValue(optionValue: string) {
    return this.multiple ? this.value?.includes(optionValue) : this.value === optionValue;
  }
}
